import React from "react";
import { AppProps } from "next/app";
import Script from "next/script";
import "../app/globals.css";
import "@/lib/trustedTypes";
import AppContent from "@/components/AppContent";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { RegionProvider } from "@/contexts/RegionContext";

export default function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      {/* Hotjar Tracking Code */}
      <Script
        id="hotjar-init"
        strategy="afterInteractive"
        dangerouslySetInnerHTML={{
          __html: `
            (function(h,o,t,j,a,r){
                h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
                h._hjSettings={hjid:2343482,hjsv:6};
                a=o.getElementsByTagName('head')[0];
                r=o.createElement('script');r.async=1;
                r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
                a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `,
        }}
      />
      <RegionProvider>
        <LanguageProvider>
          <AppContent
            Component={Component}
            pageProps={pageProps}
            manropeClassName=""
          />
        </LanguageProvider>
      </RegionProvider>
    </>
  );
}
